export default __webpack_public_path__ + "static/img/p-logo.1e46030.jpg";